import {useEffect, useContext} from 'react';
import Spinner from '../../Utils/Spinner';
import TokenContext from '../../context/Token/TokenContext';
import clienteAxios from '../../Utils/axios';
const { validate, format } = require("../../Utils/ValidateRut")

const ValidacionComponent = ({ history, location }) => {

const tokenContext = useContext(TokenContext);
const { Active_Token_F, Redirect_F, redirect_login } = tokenContext;


const ConsultaClaveUnica = async (state, code) => {
  try {
    const dataForm = new FormData()
    dataForm.append("state", state)
    dataForm.append("code", code)

    const respuesta = await clienteAxios.post("claveunica/", dataForm)

    if (respuesta.status === 200) {
      let rut64 = btoa(format(respuesta.data.run+respuesta.data.dv))
      Active_Token_F(rut64)
      localStorage.setItem('code', rut64)
     
    }else{
      window.location.href="https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout";
      const respuesta = await clienteAxios.get("claveunica/url/");    

      setTimeout(() => {
        window.location.href = respuesta.data.url;

        window.gtag("event", "ingreso_clave_unica", {
          event_category: "access",
          event_label: "login"
        });
      }, 5000);
    }
  } catch (error) {
    console.log(error)    
    window.location.href="https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout";
      const respuesta = await clienteAxios.get("claveunica/url/");    

      setTimeout(() => {
        window.location.href = respuesta.data.url;

        window.gtag("event", "ingreso_clave_unica", {
          event_category: "access",
          event_label: "login"
        });
      }, 5000);
  }
}

  useEffect(() => {
    var Parametros = new URLSearchParams(location.search)
    const state = Parametros.get("state")
    const code = Parametros.get("code")

    if(state && code){

      ConsultaClaveUnica(state, code)
    }else if (state) {
      let checkBase64 = btoa(atob(state)) === state;
        if(checkBase64){
        let rut = atob(state);
          if(validate(rut)){
            Active_Token_F(state)
            localStorage.setItem('code', state)
          }else{
            history.push('/');
          }
        }else{
          history.push('/');
        }
          
    }else{
      history.push('/');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(redirect_login){
        Redirect_F(false)
        history.push('/formulario/');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirect_login])

    return (  

        <Spinner/>
    );
}
 
export default ValidacionComponent;